/**
 * Кабинет это отдельный пакет, код бэкенда он не импортирует, поэтому текст
 * заведён здесь же, отдельной константой. Источник правды и формулировка:
 * CCBILL_REFUND_UNSUPPORTED_MESSAGE в
 * backend/src/domains/payments/services/RefundService.ts. Синхронизировать
 * текст при его изменении вручную.
 */
export const CCBILL_REFUND_UNSUPPORTED_MESSAGE =
  "Возврат по платежу CCBill оформляется в кабинете CCBill: доступа к их API возвратов у нас нет";
